<template>
  <div class="gywm">
    <div class="banner">
      <div class="img">
        <img :src="this.$store.getters.banner[this.$route.path]" />
      </div>
    </div>

    <div class="content">
      <div class="contentDiv">
        <div class="contentTxt" v-html="content"></div>
        <!-- <div class="contentTxt">
          <p class="title">关于我们</p>
          <img src="../../assets/about.png" style="    width: 100%;" />
          <div class="aboutcon">
            <p style="text-align: left;">
              在东营市东营区境内，诞生了一颗耀眼的明珠--嘉盛陵园。嘉盛陵园，是经省、市、区政府民政部门核准，由市、区政府规划，建委、国土、物价部门批准，并经工商、税务部门注册登记，没有任何遗留问题的永久性景观园林。
            </p>
            <p style="text-align: left;">
              客户将自己的亲人安葬在这里，将会得到有东营区民政局和嘉盛陵园签发的《墓穴永久使用证》及(安葬证书)从法律上保障了客户的合法权益，是客户放心的首选之地。
            </p>
            <p style="text-align: left;">
              嘉盛陵园，离城市最近，大大方便了东营市城区居民安葬逝者，祭奠亲人。并且，24小时提供网络监控和保安执勤，全方位确保园区的安全。园区已经开通城区到园区的专线班车，为客户提供往返交通车。同时这里有优秀的员工为广大客户提供优质服务，她们怀着一颗“安葬一位逝者，温暖、抚慰一个家庭”的情怀，兢兢业业，热情、周到地为大家服务。
            </p>
            <p style="text-align: left;">
              嘉盛陵园，始终把殡葬改革和社会效益放在第一位。坚特平价出售福位，从不受任何物价上涨因素的影响，总是以低价入市，逐步稳定接轨政府的市场指导价格水准，真正为东营百姓提供一个消费合理的生态园。
            </p>
            <p style="text-align: left;">
              几年来，感人的故事时常发生在这个园区，许多客户迸发出一个共同的声音“这里是逝者温馨的港湾，这里的员工胜似自己的亲人!"
            </p>
            <p style="text-align: left;">
              嘉盛陵园，在殡葬改革中由于出色的工作业绩，被中国殡葬协会吸纳为会员单位。无论是业内人士来检查，还是各界朋友对此都有极高评价。嘉盛陵园在国内和东营本地，享有很高的声誉和知名度。
            </p>
            <p style="text-align: left;">
              演绎美好人生，体现人文关怀，提供星级服务，打造齐鲁品牌，创新生态环境，传承纪念文化，这是嘉盛陵园永远追求的目标。放心吧，亲爱的客户!嘉盛的全体员工向您承诺，时刻为您提供周到、热情的服务，希望您把我们当亲人来召唤吧
            </p>
            <p style="text-align: left;">
              嘉盛陵园，旨在改变旧有的告别模式，让告别变美丽，生命得以延续。
            </p>
            <p style="text-align: left;">
              图片暂时这句话
              我们的宗旨是让两个世界的人都满意。
            </p>
            <p class="title">公司业务</p>
            <img src="../../assets/gsyw.png" style="width: 100%;margin: .53rem auto;" />
            <p class="title">服务保障</p>
            <div>
              <b>合法保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />嘉盛陵园是经省、市、区三级民政局核准，由市，区人民政府、规划局、物价局、建委、国土局批准开发建设，并经工商、税务注册登记，属山东省首批合格公墓是手续最全、最完善、最规范的永久性生态陵园。

              <br /><b>法律保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />客户承购墓穴将付清全款及办理手续费后，本园核发代表消费者合法权益的《墓穴永久使用权证》及《安葬证书》并加印了东营区民政局的公章和经营单位公章，两证受国家的法律保护。

              <br /><b>价格保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />本园所售产品的价格均经市、区物价局的审核批准，客户承购产品缴清全部款项，颁发了《墓穴永久使用权证》及《安葬证书》后，不受任何物价上涨因素的影响。

              <br /><b>背景保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />嘉盛陵园由东营区民政局和胜利油田工会联手合作开发建设，政治无风险，经济投入有可靠充足的保障并且东营市、区二级政府及胜利油田管理局对我园尚有着广泛的支持力度。

              <br /><b>品牌保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />嘉盛陵园在社会上享有很高的“知名度”和“美誉度”，是东营市唯一一家获得了中央民政部主办的“中国殡葬协会会员单位"，同时也是东营市唯一一家获得中国保护消费者权益促进会，中国殡葬业监督管理委员会颁发的“全国首批社会放心殡葬机构”的单位，又是东营市唯一家获得省民政厅“2007年度公墓年检合格”单位，三项殊荣在东营市独一无二。

              <br /><b>安全保障</b>
              <img src="../../assets/about.png" style="    height:80px;width: 100%;" />
              <br />嘉盛陵园属国土局以“公墓”用途划拨给的500亩土地，属“永久”性经营单位，园内安置了监控设施并24小时的保安值勤服务，确保了墓区全方位的安全
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guanyuwomen',
  components: {},
  data() {
    return {
      content: '',
    }
  },
  methods: {},
  created() {
    // this.getDate()
    var that = this
    this.$queryOne('OweArticle', { code: 'ABOUT' }, ['content'], function(res) {
      console.log(12)
      that.content = res.data['content']
    })
  },
}
</script>

<style>
.gywm .aboutcon {
  font-size: 0.37rem;
  color: #666;
  line-height: 0.75rem;
}
.gywm .content {
  padding: 0 0.4rem;
  background: #fff;
}
.gywm .banner {
  height: 3.73rem;
}
.gywm .title {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
  margin-top: 0.5rem;
  margin-bottom: 0.53rem;
}
.gywm .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.gywm .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.gywm .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap; */
  word-wrap: break-word;
}
.gywm .contentTxt p {
  margin: 0.5rem 0;
}
</style>
